export default __webpack_public_path__ + "static/media/carbide.9e1bd205.svg";